import { render, staticRenderFns } from "./menu-investment.component.vue?vue&type=template&id=2f9767ff&scoped=true"
import script from "./menu-investment.component.vue?vue&type=script&lang=js"
export * from "./menu-investment.component.vue?vue&type=script&lang=js"
import style0 from "./menu-investment.component.vue?vue&type=style&index=0&id=2f9767ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9767ff",
  null
  
)

export default component.exports